import template from './paginationBar.html';
import controller from './paginationBar.controller';

let paginationBarComponent = () => {
  return {
    restrict: 'E',
    require: '^^tableComponent',
    template,
    controller,
    controllerAs: 'vm',
    link: ($scope, $elem, $attr, tableComponent) => {
      $scope.vm.tableComponent = tableComponent;
      $scope.$watch('vm.tableComponent.tableData.content', () => {
        $scope.vm.setDisplayedPageNumbers();
      });
    }
  };
};

export default paginationBarComponent;




// WEBPACK FOOTER //
// ./app/components/paginationBar/paginationBar.component.js